"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCard = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const dateUtils = __importStar(require("../../../utils/dateUtils"));
const IconCalendar_1 = require("../../icons/IconCalendar");
const IconEdit_1 = require("../../icons/IconEdit");
const IconTime_1 = require("../../icons/IconTime");
const ResourceCalendarModal_1 = require("../../resource-calendar-modal/ResourceCalendarModal");
const ResourceIconWithColor_1 = require("../../resource-icon-with-color/ResourceIconWithColor");
const ResourceCard = (props) => {
    var _a, _b, _c;
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const invalidClass = props.isInvalid ? "text-danger" : "";
    return (react_1.default.createElement(Card_1.default, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "" },
        react_1.default.createElement(Card_1.default.Body, null,
            props.editable && (react_1.default.createElement(Button_1.default, { className: "float-right no-print", variant: props.isInvalid ? "outline-danger" : "light", size: "sm", onClick: () => showModal(react_1.default.createElement(ResourceCalendarModal_1.ResourceCalendarModal, { booking: props.booking, onClose: hideModal, onOk: (newBooking) => {
                        props.onBookingChange(newBooking);
                        hideModal();
                    } })) },
                react_1.default.createElement(IconEdit_1.IconEdit, null),
                " Edit")),
            react_1.default.createElement("dl", null,
                react_1.default.createElement("dt", null, (_b = props.booking.configResource) === null || _b === void 0 ? void 0 : _b.resourceItem.type),
                react_1.default.createElement("dd", { className: "strong mb-0 " },
                    react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: (_c = props.booking.configResource) !== null && _c !== void 0 ? _c : props.booking.getResourceId() }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(IconCalendar_1.IconCalendar, null),
                        " ",
                        react_1.default.createElement("span", { className: invalidClass }, dateUtils.formatDate(props.booking.start))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(IconTime_1.IconTime, null),
                        " ",
                        react_1.default.createElement("span", { className: invalidClass },
                            dateUtils.formatTime(props.booking.start),
                            " -",
                            " ",
                            dateUtils.formatTime(props.booking.end)))))),
        modal));
};
exports.ResourceCard = ResourceCard;
